"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7797],{

/***/ 25413:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Footer_Footer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntry.ts
var useEntry = __webpack_require__(99214);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/layout/WidthContainerCompensator/WidthContainerCompensator.tsx
var WidthContainerCompensator = __webpack_require__(34626);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/navigation/NavItem/NavItem.tsx
var NavItem = __webpack_require__(84473);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/links/getLinkWithParams.ts
var getLinkWithParams = __webpack_require__(54780);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/user/referralProgram/index.ts
var referralProgram = __webpack_require__(2487);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(28733);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTONavigationData.ts
var useStrapiWSTONavigationData = __webpack_require__(14159);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(4833);
// EXTERNAL MODULE: ./src/compositions/navigation/messages.ts
var messages = __webpack_require__(8323);
;// CONCATENATED MODULE: ./src/compositions/Footer/components/Nav/useNav.ts









const useNav = ()=>{
    const isTheShopEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.theShop);
    const isCandleSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleSubscription);
    const isFragranceFamiliesPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.fragranceFamiliesPage);
    const isNotesLibraryPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.noteLibPages);
    const isSaksCollaborationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    const isScentHoroscopeEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentHoroscope);
    const isScentbirdPodcastEntryPointsEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.scentbirdPodcastEntryPoints);
    const isDriftEcommercePromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftEcommercePromo);
    const isCOARShopPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.coarShopPage);
    const isStrapiCareersPageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.strapiCareersPage);
    const isHomeFooterSeoKeywordEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.homeFooterSeoKeyword) === "b";
    const { gender, hasScentProfile } = (0,user/* useUser */.aF)();
    const strapiWSTONavigationData = (0,useStrapiWSTONavigationData/* default */.Z)();
    const isStrapiWSTONavigationEnabled = Boolean(strapiWSTONavigationData);
    const { privateSale } = (0,usePrivateSale/* default */.Z)();
    const isPrivateSaleEnabled = Boolean(privateSale);
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const isLead = subscription?.hasNeverSubscribed;
    const isSubscribed = subscription?.isSubscribed;
    const isBuyQueueEnabled = subscription?.stateOptions?.canBuyQueue;
    const canApplyTossInOffer = subscription?.canApplyTossInOffer;
    const { caseSubscription } = (0,subscriptionAddons/* useCaseSubscription */.PZ)();
    const isCaseSubscriptionEnabled = caseSubscription?.isEnabled;
    const { driftSubscription } = (0,subscriptionAddons/* useDriftSubscription */.RD)();
    const isDriftSubscriptionEnabled = driftSubscription?.isEnabled;
    const { candleSubscription } = (0,subscriptionAddons/* useCandleSubscription */.pj)();
    const isCandleSubscriptionVisible = Boolean(isCandleSubscriptionEnabled && candleSubscription?.isEnabled);
    const { stats: { available } } = (0,referralProgram/* useReferralInvites */.n)();
    return (0,react.useMemo)(()=>{
        const data = [
            {
                id: "footer-mySubscription",
                title: isSubscribed ? messages/* default */.Z.mySubscription : messages/* default */.Z.scentbird,
                list: [
                    {
                        id: "footer-mySubscription-perfumes",
                        title: messages/* default */.Z.perfumes,
                        to: links/* default */.ZP.subscription.perfumes
                    },
                    {
                        id: "footer-mySubscription-colognes",
                        title: messages/* default */.Z.colognes,
                        to: links/* default */.ZP.subscription.colognes
                    },
                    {
                        id: "footer-mySubscription-beauty",
                        title: messages/* default */.Z.beauty,
                        to: links/* default */.ZP.subscription.beauty
                    },
                    isLead && isHomeFooterSeoKeywordEnabled && {
                        id: "footer-perfume-subscription",
                        title: messages/* default */.Z.perfumeSubscription,
                        href: constants/* default */.Z.externalLinks.scentbirdBlog
                    }
                ].filter(Boolean),
                withColumns: false
            },
            {
                id: "footer-shop",
                title: messages/* default */.Z.shop,
                list: [
                    isDriftEcommercePromoEnabled && {
                        id: "footer-shop-drift-ecommerce-promo",
                        title: messages/* default */.Z.driftEcommercePromo,
                        to: `${(0,getLinkWithParams/* default */.Z)(links/* default */.ZP.brand, {
                            name: "drift"
                        })}?productInputSource=THE_EDIT&sourceProductGroup=GiftSet`
                    },
                    isCOARShopPageEnabled && {
                        id: "header-shop-coar",
                        title: messages/* default */.Z.coarShopPage,
                        to: links/* default */.ZP.shop.coar
                    },
                    isTheShopEnabled && {
                        id: "footer-shop-edit",
                        title: messages/* default */.Z.edit,
                        to: links/* default */.ZP.shop.theEdit
                    },
                    {
                        id: "footer-shop-scentbirdCases",
                        title: messages/* default */.Z.scentbirdCases,
                        to: links/* default */.ZP.shop.scentbirdCases
                    },
                    isTheShopEnabled && {
                        id: "footer-shop-fullSizeFragrances",
                        title: messages/* default */.Z.fullSizeFragrances,
                        to: gender === "FEMALE" ? links/* default */.ZP.shop.perfumes : links/* default */.ZP.shop.colognes
                    },
                    isTheShopEnabled && {
                        id: "footer-shop-bathBody",
                        title: messages/* default */.Z.bathBody,
                        to: links/* default */.ZP.shop.bathBody
                    },
                    isTheShopEnabled && {
                        id: "footer-shop-candlesHomeScents",
                        title: messages/* default */.Z.candlesHomeScents,
                        to: links/* default */.ZP.shop.candlesHomeScents
                    },
                    {
                        id: "footer-shop-gifts",
                        title: messages/* default */.Z.gifts,
                        to: links/* default */.ZP.gifts
                    }
                ].filter(Boolean),
                withColumns: true
            },
            {
                id: "footer-discover",
                title: messages/* default */.Z.discover,
                list: [
                    {
                        id: "footer-discover-scentProfile",
                        title: messages/* default */.Z.scentProfile,
                        to: hasScentProfile ? links/* default */.ZP.scentProfile : links/* default */.ZP.smartRecommendations
                    },
                    isSaksCollaborationEnabled && {
                        id: "footer-discover-scentbird-select",
                        title: messages/* default */.Z.scentbirdSelect,
                        to: links/* default */.ZP.scentbirdSelect
                    },
                    {
                        id: "footer-discover-allBrands",
                        title: messages/* default */.Z.allBrands,
                        to: links/* default */.ZP.brands
                    },
                    isScentHoroscopeEnabled && {
                        id: "footer-discover-scentHoroscope",
                        title: messages/* default */.Z.scentHoroscope,
                        to: links/* default */.ZP.scentHoroscope
                    },
                    isStrapiWSTONavigationEnabled && {
                        id: "footer-discover-featuredBrand",
                        title: messages/* default */.Z.featuredBrand,
                        to: strapiWSTONavigationData.navLink
                    },
                    isNotesLibraryPageEnabled && {
                        id: "footer-discover-notesLibrary",
                        title: messages/* default */.Z.notesLibrary,
                        to: links/* default */.ZP.notes
                    },
                    isFragranceFamiliesPageEnabled && {
                        id: "footer-discover-fragranceFamilies",
                        title: messages/* default */.Z.fragranceFamilies,
                        to: links/* default */.ZP.fragranceFamilies
                    },
                    {
                        id: "footer-discover-scentBlog",
                        title: messages/* default */.Z.scentBlog,
                        toTab: links/* default */.ZP.blog
                    },
                    isScentbirdPodcastEntryPointsEnabled && {
                        id: "footer-discover-podcast",
                        title: messages/* default */.Z.scentWorldPodcast,
                        href: constants/* default */.Z.externalLinks.scentbirdPodcast
                    }
                ].filter(Boolean),
                withColumns: true
            },
            isSubscribed && {
                id: "footer-member-perks",
                title: messages/* default */.Z.memberPerks,
                list: [
                    isDriftSubscriptionEnabled && {
                        id: "footer-member-perks-driftSubscription",
                        title: messages/* default */.Z.driftSubscription,
                        to: links/* default */.ZP.driftSubscription
                    },
                    isCaseSubscriptionEnabled && {
                        id: "footer-member-perks-caseSubscription",
                        title: messages/* default */.Z.caseSubscription,
                        to: links/* default */.ZP.caseSubscription
                    },
                    isCandleSubscriptionVisible && {
                        id: "footer-member-perks-candleSubscription",
                        title: messages/* default */.Z.candleSubscription,
                        to: links/* default */.ZP.candleSubscription
                    },
                    isBuyQueueEnabled && {
                        id: "footer-member-perks-buyYourQueue",
                        title: messages/* default */.Z.buyYourQueue,
                        to: links/* default */.ZP.buyQueue
                    },
                    isPrivateSaleEnabled && {
                        id: "footer-member-perks-privateSale",
                        title: messages/* default */.Z.privateSale,
                        to: links/* default */.ZP.privateSale
                    },
                    Boolean(available) && {
                        id: "footer-member-perks-referralProgram",
                        title: {
                            ...messages/* default */.Z.newReferral,
                            values: {
                                available,
                                freeFragranceClassName: "text-gold-30",
                                spanClassName: "bg-gold-50 text-white"
                            }
                        },
                        to: links/* default */.ZP.invite
                    },
                    canApplyTossInOffer && {
                        id: "footer-member-perks-lastMinuteAddons",
                        title: messages/* default */.Z.lastMinuteAddons,
                        to: links/* default */.ZP.tossIn
                    }
                ].filter(Boolean),
                withColumns: true
            },
            {
                id: "footer-about-scentbird",
                title: messages/* default */.Z.aboutScentbird,
                list: [
                    {
                        id: "footer-about-scentbird-support",
                        title: messages/* default */.Z.support,
                        toTab: "https://scentbird.zendesk.com/hc/en-us"
                    },
                    {
                        id: "footer-about-scentbird-aboutUs",
                        title: messages/* default */.Z.aboutUs,
                        to: links/* default */.ZP.team
                    },
                    {
                        id: "footer-about-scentbird-careers",
                        title: messages/* default */.Z.careers,
                        toTab: isStrapiCareersPageEnabled ? links/* default */.ZP.careers : constants/* default */.Z.externalLinks.ripplingJobs
                    },
                    {
                        id: "footer-about-scentbird-press",
                        title: messages/* default */.Z.press,
                        to: links/* default */.ZP.press
                    }
                ],
                withColumns: true
            }
        ];
        return data.filter(Boolean);
    }, [
        canApplyTossInOffer,
        gender,
        hasScentProfile,
        strapiWSTONavigationData,
        isStrapiWSTONavigationEnabled,
        isBuyQueueEnabled,
        isCandleSubscriptionVisible,
        isCaseSubscriptionEnabled,
        isPrivateSaleEnabled,
        isFragranceFamiliesPageEnabled,
        isNotesLibraryPageEnabled,
        isHomeFooterSeoKeywordEnabled,
        isLead,
        isSubscribed,
        isTheShopEnabled,
        isSaksCollaborationEnabled,
        isScentHoroscopeEnabled,
        isScentbirdPodcastEntryPointsEnabled,
        isDriftEcommercePromoEnabled,
        available,
        isCOARShopPageEnabled,
        isDriftSubscriptionEnabled,
        isStrapiCareersPageEnabled
    ]);
};
/* harmony default export */ const Nav_useNav = (useNav);

;// CONCATENATED MODULE: ./src/compositions/Footer/components/Nav/Nav.tsx








const Nav = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const sections = Nav_useNav();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: isMobile ? null : "grid grid-cols-4 grid-rows-2 gap-x-40 gap-y-24",
        "aria-label": "Footer",
        children: sections.map((section, index)=>{
            const { id: titleId, list, withColumns } = section;
            const title = section.title;
            const sectionClassName = (0,clsx/* default */.Z)(isMobile ? "mb-48" : "w-full", !isMobile && (index ? "row-span-2" : "row-span-1"));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: sectionClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        id: titleId,
                        className: "mb-8",
                        message: section.title,
                        tag: "h3",
                        style: "h9",
                        color: "gold-30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: withColumns && isMobile ? "columns-2" : null,
                        "aria-labelledby": titleId,
                        children: list.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem/* default */.Z, {
                                    className: "link-gray-30 inline-block py-12",
                                    to: item.to,
                                    toTab: item.toTab,
                                    href: item.href,
                                    title: item.title,
                                    style: "p3",
                                    onClick: ()=>{
                                        (0,analytics/* track */.j)("Footer link click", {
                                            blockName: typeof section.title === "string" ? section.title : section.title.en,
                                            title: typeof item.title === "string" ? item.title : item.title.en,
                                            link: item.to || item.toTab
                                        });
                                    },
                                    "data-testid": item.id
                                })
                            }, item.id))
                    })
                ]
            }, title.en);
        })
    });
};
/* harmony default export */ const Nav_Nav = (Nav);

// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/compositions/Footer/components/ApplicationStoreButtons/ApplicationStoreButtons.tsx






const ApplicationStoreButtons = (props)=>{
    const { className } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex items-center justify-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                className: "inline-block px-4 text-white",
                toTab: "https://app.adjust.com/r7804xw?fallback=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.scentbird",
                onClick: ()=>{
                    (0,analytics/* track */.j)("GooglePlay badge click", {
                        placement: "Footer"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "other/google-play"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                className: "inline-block px-4 text-white",
                toTab: "https://app.adjust.com/r7804xw?fallback=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fscentbird-beauty-subscription%2Fid1444093439",
                onClick: ()=>{
                    (0,analytics/* track */.j)("App Store badge click", {
                        placement: "Footer"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "other/apple-store"
                })
            })
        ]
    });
};
/* harmony default export */ const ApplicationStoreButtons_ApplicationStoreButtons = (ApplicationStoreButtons);

;// CONCATENATED MODULE: ./src/compositions/Footer/components/SocialNav/SocialNav.tsx





const socialLinks = [
    {
        id: "Instagram",
        name: "32/instagram",
        to: "https://instagram.com/scentbird"
    },
    {
        id: "Facebook",
        name: "32/facebook",
        to: "https://www.facebook.com/scentbird"
    },
    {
        id: "Twitter",
        name: "32/twitter",
        to: "https://twitter.com/scentbird"
    },
    {
        id: "Pinterest",
        name: "32/pinterest",
        to: "https://www.pinterest.com/scentbird/"
    },
    {
        id: "TikTok",
        name: "32/tiktok",
        to: "https://www.tiktok.com/@scentbird"
    }
];
const SocialNav = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center",
        children: socialLinks.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                className: "px-16 py-8 text-white",
                toTab: item.to,
                onClick: ()=>{
                    (0,analytics/* track */.j)("Social network icon click", {
                        placement: "Footer",
                        socialNetwork: item.id
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: item.name
                })
            }, item.id))
    });
/* harmony default export */ const SocialNav_SocialNav = (SocialNav);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
;// CONCATENATED MODULE: ./src/compositions/Footer/components/Basement/messages.ts
/* harmony default export */ const Basement_messages = ({
    allRightReserved: {
        en: `
      SCENTBIRD ©{year}, All right reserved.<br class="onlyMobile" /> Made with love in New York City.
    `
    },
    address: {
        en: "1600 Perrineville Road, Ste. 2 – 395 Monroe Twp., NJ 08831"
    },
    privacyPolicy: {
        en: "Privacy Policy"
    },
    sellMyInfo: {
        en: "Don’t sell my info"
    },
    termsConditions: {
        en: "Terms & Conditions"
    },
    cookies: {
        en: "Cookies"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Footer/components/Basement/Basement.tsx












const Basement = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isOsanoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.osano);
    const isCheqAiEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.cheqAi);
    const year = new Date().getFullYear();
    const legalLinksClassName = (0,clsx/* default */.Z)("flex", {
        "justify-between": isMobile,
        "justify-center": !isMobile
    });
    const legalLinks = [
        {
            title: Basement_messages.privacyPolicy,
            toTab: links/* default */.ZP.privacy
        },
        {
            title: Basement_messages.sellMyInfo,
            toTab: links/* default */.ZP.ccpa
        },
        {
            title: Basement_messages.termsConditions,
            toTab: links/* default */.ZP.terms
        }
    ];
    if (isOsanoEnabled || isCheqAiEnabled) {
        legalLinks.push({
            title: Basement_messages.cookies,
            onClick: ()=>{
                try {
                    if (isCheqAiEnabled) {
                        window.Bootstrapper.gateway.openModal();
                    } else window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
                } catch (error) {
                    logger/* default */.Z.warn('Click "Cookies" while script is not loaded');
                }
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: isMobile ? "mt-24" : "mt-32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: {
                    ...Basement_messages.allRightReserved,
                    values: {
                        year
                    }
                },
                style: isMobile ? "p4" : "p5",
                color: "gray-30",
                align: "center",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-16",
                message: Basement_messages.address,
                color: "gray-50",
                align: "center",
                style: "p5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: isMobile ? "mt-32" : "mt-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: legalLinksClassName,
                    children: legalLinks.map((item, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                            className: (0,clsx/* default */.Z)("link-gray-40 cursor-pointer text-p5", !isMobile && "mx-20"),
                            toTab: item.toTab,
                            message: item.title,
                            onClick: item.onClick
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ const Basement_Basement = (Basement);

;// CONCATENATED MODULE: ./src/compositions/Footer/Footer.tsx










const Footer = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const pathname = (0,contexts/* usePathname */.jD)();
    const initPathname = (0,react.useRef)(undefined);
    const [ref, entry] = (0,useEntry/* default */.Z)({
        observerProps: {
            threshold: 0.25
        }
    });
    const isVisible = entry?.isIntersecting;
    // TODO: Remove tracking when ab test CRO-226 and CRO-335 is over
    (0,react.useEffect)(()=>{
        // Fire event once per page view
        // check for scrollY to avoid firing while page is loading and footer is flashing in viewport
        if (isVisible && pathname !== initPathname.current && window.scrollY > 0) {
            (0,analytics/* track */.j)("Footer display");
            initPathname.current = pathname;
        }
    }, [
        isVisible,
        pathname,
        subscription?.hasNeverSubscribed
    ]);
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
            className: "bg-black px-40 pb-32 pt-56",
            id: "footer",
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-48 mt-36 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "other/scentbird-monogram",
                        color: "gold-30"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationStoreButtons_ApplicationStoreButtons, {
                    className: "mb-24"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialNav_SocialNav, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainerCompensator/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Basement_Basement, {})
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-black pb-32 pt-72",
        id: "footer",
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            size: 944,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-48 flex items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            className: "mr-80",
                            name: "other/scentbird-monogram",
                            color: "gold-30"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationStoreButtons_ApplicationStoreButtons, {
                            className: "mr-12"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialNav_SocialNav, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basement_Basement, {})
            ]
        })
    });
};
/* harmony default export */ const Footer_Footer = (Footer);


/***/ })

}]);